export default __webpack_public_path__ + "static/media/dss.1c911635.webp";